// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"30ab0865","477":"650352c6","742":"871c3b32","787":"4c72bb55"}[chunkId] + ".chunk.js";
};